import React, { useEffect, useState } from "react";
import { Row, Col, Card, Form, InputGroup, Modal, Button, Table, Badge } from 'react-bootstrap';
import { Link } from "react-router-dom";

import { testmenuAgencyList } from "../../api/testMenuService";

function MyPage() {
    const [agencyList, setAgencyList] = useState([]);

    const fetcAgencyList = async () => {
      try {
        const result = await testmenuAgencyList();
        //console.log("Fetched agencies:", result);
  
        setAgencyList(result);
      } catch (error) {
        console.log("Error fetching list:", error);
      }
    };
  
    useEffect(() => {
        fetcAgencyList();
    }, []);
  
    return (
        <Card className="mt-4">
            <Card.Body>
                <Table responsive bordered hover size="sm" className="mt-1">
                <thead>
                    <tr>
                        <th style={{ width: '3em' }}>No.</th>
                        <th>Agency Name</th>
                        <th>Phone No.</th>
                    </tr>
                </thead>
                <tbody>
                {agencyList.map((item, index) => (
                    <tr>
                        <td>{index + 1}.</td>
                        <td>  <Link to={`/testmenu/agency/${item.id}`} className="">{item.agencyName}</Link></td>
                        <td>{item.phoneNumber}</td>
                    </tr>
                ))}
                </tbody>
                </Table>
            </Card.Body>
        </Card>
    );
}

export default MyPage;